










































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import AccountHelpers, { Account } from "@/models/account";
import BillingAccountHelpers, { BillingAccount } from "@/models/billingAccount";
import AccountSearchHelpers, { AccountSearch } from "@/models/accountsearch";
import loader from "@/components/loader.vue";
import accountsApi from "@/services/accounts";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Getter, Action, Mutation } from "vuex-class";

// import CreateUpdateAccount from "./CreateUpdateAccount.vue";
// import FindAccount from "./FindAccount.vue";

import BillingAccountComponent from "./BillingAccount.vue";
import HearXAccountComponent from "./hearXAccount.vue";

import { NSLog } from "@/helpers/log";
import { save } from "@/helpers/storage";
import { Order } from "@/models/order";
const log = NSLog("view/PlaceUserOrder");

@Component({
  components: {
    loader,
    // CreateUpdateAccount,
    // FindAccount
    HearXAccountComponent,
    BillingAccountComponent,
  },
})
export default class SelectCustomer extends Vue {
  private get hxAccountDisplayText() {
    return this.order && this.order.account
      ? AccountHelpers.DisplayText(this.order.account)
      : "";
  }

  private get billingAccountDisplayText() {
    return this.order && this.order.billing_account
      ? BillingAccountHelpers.DisplayText(this.order.billing_account)
      : "";
  }

  // private get valid() {
  //   return AccountHelpers.Valid(this.updatedAccount);
  // }

  // private get nextButton() {
  //   // if account doesn't have an id, create
  //   if (!this.loadedAccount || !this.loadedAccount.id) {
  //     return 1;
  //   }

  //   // if account has an id and has been updated, update
  //   if (this.loadedAccount.id && this.AccountUpdated) {
  //     return 2;
  //   }

  //   // else next
  //   return 0;
  // }

  // get AccountUpdated() {
  //   return !AccountHelpers.Same(this.loadedAccount, this.updatedAccount);
  // }
  // @Mutation("setLastErr") public setLastErr: any;

  // // order passed as prop, then emit('update',{field: value}, sync?) to update.
  @Prop({ required: true }) public order?: Order;
  private pannelsIdx = 0;
  private loading = true;

  // private loadedAccount: Account = AccountHelpers.New();
  // private updatedAccount: Account = AccountHelpers.New();

  // // set selected account, also update global selected account
  // @Action("setGlobalSelectedAccount") private setGlobalSelectedAccount: any;
  // public setLoadedAccount(acc?: Account) {
  //   this.loadedAccount = acc ? acc : AccountHelpers.New();
  //   if (!AccountHelpers.Same(this.loadedAccount, this.updatedAccount)) {
  //     this.updatedAccount = AccountHelpers.Clone(this.loadedAccount);
  //   }
  // }
  // public setUpdatedAccount(acc?: Account) {
  //   if (!AccountHelpers.Same(acc, this.updatedAccount)) {
  //     this.updatedAccount = acc ? acc : AccountHelpers.New();
  //   }
  // }

  // public async next() {
  //   this.setLastErr();
  //   this.updateAccount();
  // }

  // // create account section
  // public async create() {
  //   this.setLastErr();
  //   this.loading = true;
  //   try {
  //     this.updatedAccount = await accountsApi.RegisterAccount(
  //       this.updatedAccount
  //     );
  //     this.updateAccount();
  //   } catch (e) {
  //     this.setLastErr(e);
  //   }
  //   this.loading = false;
  // }

  // // create account section
  // public async update() {
  //   this.setLastErr();
  //   this.loading = true;
  //   try {
  //     this.updatedAccount = await accountsApi.UpdateAccount(
  //       this.updatedAccount
  //     );
  //     this.updateAccount();
  //   } catch (e) {
  //     this.setLastErr(e);
  //   }
  //   this.loading = false;
  // }
  // public createNew() {
  //   this.setLoadedAccount(AccountHelpers.New());
  // }

  // // created, load and set account if if set
  private async created() {
    //   this.loading = true;
    //   if (this.order && this.order.account_id) {
    //     try {
    //       const acc = await accountsApi.GetAccountByID(this.order.account_id);
    //       this.setLoadedAccount(acc);
    //     } catch (e) {
    //       this.setLastErr(e);
    //     }
    //   }
    this.loading = false;
  }
  // private updateAccount() {
  //   const accID = this.updatedAccount ? this.updatedAccount.id : 0;
  //   if (!accID) {
  //     return;
  //   }

  //   this.setGlobalSelectedAccount(this.updatedAccount);
  //   this.$emit("update", { account_id: accID }, true, "packages");
  // }
}
